class GiftSelection extends HTMLElement {
  constructor() {
    super();

    document
      .querySelector(".button-disabler")
      .addEventListener("click", this.handleGiftAddClick);

    this.addEventListener("change", this.handleGiftChange);
    this.giftMessage = this.querySelector(".grid-card__message");

    this.wrapOnlyLabel = "GIFT WRAP INSTRUCTIONS";
    this.wrapWithMessageLabel = "GIFT WRAP INSTRUCTIONS & GIFT CARD MESSAGE (PLEASE READ NOTE BELOW)";
    this.wrapOnlyPlaceholder = "Please specify your gift wrap instructions";
    this.wrapWithMessagePlaceholder = "Due to a technical issue on our website, your gift wrap / gift message request will only be captured if text is entered in this text field. Please type “gift wrap only” or “gift wrap with message card” (& your corresponding gift message) here to ensure your request is processed. Thank you for your patience while we fix the issue.";
  }

  handleGiftChange() {
    if (!this.querySelector("input[form='GiftSelection']:checked")) return;
    const selectedGift = this.querySelector(
      "input[form='GiftSelection']:checked"
    )
      .getAttribute("product-title")
      .toLowerCase();

    selectedGift.includes("message")
      ? (this.giftMessage.querySelector("label").innerHTML = this.wrapWithMessageLabel,
        document.getElementById("Cart-note").placeholder = this.wrapWithMessagePlaceholder)
      : (this.giftMessage.querySelector("label").innerHTML = this.wrapOnlyLabel,
        document.getElementById("Cart-note").placeholder = this.wrapOnlyPlaceholder);

    const gridCardMessage = this.querySelector(".grid-card__message");
    if (gridCardMessage) {
      gridCardMessage.style.display = 'block';
    }
  }

  async handleGiftAddClick() {
    const form = document.querySelector("#GiftSelection");
    const x = new FormData(form);
    const gift = x.get("GiftChoice");

    document.querySelector(".gift-card__error-message").innerHTML = "";

    if (!gift) {
      document.querySelector(".gift-card__error-message").innerHTML =
        "Please select your gift wrap option to proceed.";
      return;
    }

    const giftName = document
      .querySelector(`input[value="${gift}"]`)
      .getAttribute("product-title")
      .toLowerCase();

    let formData = {
      items: [{ id: parseFloat(gift), quantity: 1 }],
    };

    if (giftName.includes("message")) {
      const message = document.querySelector("[name='note']").value;
      formData.items[0].properties = {
        "Gift Message": message,
      };
    }

    await fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    window.location.href = "/checkout";
  }

  connectedCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const giftParam = urlParams.get("gift");
    if (giftParam == "true")
      document.querySelector("#gift-checkbox").checked = true;
  }
}

customElements.define("gift-selection", GiftSelection);
